"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.numItemsBankHasInBank = exports.multiplyBank = exports.addArrayToBank = exports.addItemToBank = exports.removeBankFromBank = exports.removeItemFromBank = exports.bankHasAllItemsFromBank = exports.bankHasItem = exports.resolveBank = exports.resolveNameBank = exports.bankFromLootTableOutput = exports.addBanks = void 0;
const itemID_1 = __importDefault(require("./itemID"));
/**
 * Joins an array of banks together
 * @param arrayOfBanks An array of number-keyed banks
 */
function addBanks(arrayOfBanks) {
    const newBank = {};
    for (const bank of arrayOfBanks) {
        for (const [itemID, quantity] of Object.entries(bank)) {
            const numID = parseInt(itemID);
            if (newBank[numID])
                newBank[numID] += quantity;
            else
                newBank[numID] = quantity;
        }
    }
    return newBank;
}
exports.addBanks = addBanks;
/**
 * Generate a bank based on loot table output
 * @param tableOutput
 */
function bankFromLootTableOutput(tableOutput) {
    const newBank = {};
    for (const { item, quantity } of tableOutput) {
        if (newBank[item])
            newBank[item] += quantity;
        else
            newBank[item] = quantity;
    }
    return newBank;
}
exports.bankFromLootTableOutput = bankFromLootTableOutput;
/**
 * Transforms a string-based bank to an ID-based bank
 * @param nameBank A string-based bank to convert
 */
function resolveNameBank(nameBank) {
    const newBank = {};
    for (const [name, val] of Object.entries(nameBank)) {
        newBank[itemID_1.default(name)] = val;
    }
    return newBank;
}
exports.resolveNameBank = resolveNameBank;
/**
 * Resolves a bank which uses item names or item IDs.
 * @param bank A bank to resolve
 */
function resolveBank(bank) {
    const newBank = {};
    for (const [nameOrID, val] of Object.entries(bank)) {
        const int = Number(nameOrID);
        const id = isNaN(int) ? itemID_1.default(nameOrID) : int;
        newBank[id] = val;
    }
    return newBank;
}
exports.resolveBank = resolveBank;
/**
 * Checks if a bank includes an amount or more of an item
 * @param itemBank A NumberKeyed bank
 * @param itemID The item ID to check for
 * @param quantity The quantity of items the bank should have. Defaults to 1
 */
function bankHasItem(itemBank, itemID, quantity = 1) {
    return typeof itemBank[itemID] === 'number' && itemBank[itemID] >= quantity;
}
exports.bankHasItem = bankHasItem;
/**
 * Checks if a bank includes all the items from another bank
 * @param bankToHave The source bank
 * @param bankToCheck The target bank
 */
function bankHasAllItemsFromBank(bankToCheck, bankToHave) {
    const itemsToHave = Object.entries(bankToHave);
    for (const [itemID, qty] of itemsToHave) {
        if (!bankHasItem(bankToCheck, parseInt(itemID), qty)) {
            return false;
        }
    }
    return true;
}
exports.bankHasAllItemsFromBank = bankHasAllItemsFromBank;
/**
 * Removes an item or a quantity of items from a bank
 * @param bank A NumberKeyed bank to remove from
 * @param itemID The item ID to remove
 * @param amountToRemove The quantity to remove. Defaults to 1
 */
function removeItemFromBank(bank, itemID, amountToRemove = 1) {
    const newBank = Object.assign({}, bank);
    const currentValue = bank[itemID];
    // If they don't have this item in the bank, just return it.
    if (typeof currentValue === 'undefined')
        return bank;
    // If they will have 0 or less of this item afterwards, delete it entirely.
    if (currentValue - amountToRemove <= 0) {
        delete newBank[itemID];
    }
    else {
        newBank[itemID] = currentValue - amountToRemove;
    }
    return newBank;
}
exports.removeItemFromBank = removeItemFromBank;
/**
 * Removes the contents of a bank from another bank
 */
function removeBankFromBank(targetBank, bankToRemove) {
    let newBank = Object.assign({}, targetBank);
    for (const [itemID, qty] of Object.entries(bankToRemove)) {
        newBank = removeItemFromBank(newBank, parseInt(itemID), qty);
    }
    return newBank;
}
exports.removeBankFromBank = removeBankFromBank;
/**
 * Adds an item to a bank
 * @param bank A NumberKeyed bank to add items in
 * @param itemID The item ID to add
 * @param amountToAdd Quantity of items to be added. Defaults to 1
 */
function addItemToBank(bank, itemID, amountToAdd = 1) {
    const newBank = Object.assign({}, bank);
    if (newBank[itemID])
        newBank[itemID] += amountToAdd;
    else
        newBank[itemID] = amountToAdd;
    return newBank;
}
exports.addItemToBank = addItemToBank;
/**
 * Adds an array of items in a bank
 * @param bank A NumberKeyed bank to add items to
 * @param items An array of item IDs
 */
function addArrayToBank(bank, items) {
    let newBank = Object.assign({}, bank);
    for (const item of items) {
        newBank = addItemToBank(newBank, item);
    }
    return newBank;
}
exports.addArrayToBank = addArrayToBank;
/**
 * Multiplies a bank's contents by the times specified
 * @param bank A NumberKeyed bank whose contents will be multiplied
 * @param times How many times should the contents be multiplied
 */
function multiplyBank(bank, times) {
    const newBank = Object.assign({}, bank);
    for (const [itemID] of Object.entries(newBank)) {
        newBank[parseInt(itemID)] *= times;
    }
    return newBank;
}
exports.multiplyBank = multiplyBank;
function numItemsBankHasInBank(bank, bankItemsToHave) {
    let has = 0;
    for (const itemID of Object.keys(bankItemsToHave).map((i) => parseInt(i))) {
        if (bankHasItem(bank, itemID)) {
            has++;
        }
    }
    return has;
}
exports.numItemsBankHasInBank = numItemsBankHasInBank;
//# sourceMappingURL=bank.js.map